import React, { FC, useEffect, useState, Key } from 'react';
import { Space, Modal, Button } from 'antd';
import { ActionType } from '../index';
import DeviceModal from './DeviceModal';
import styles from './index.module.scss';

export interface SelectDevicesProps {
  value?: Key[];
  onChange?: (value?: Key[]) => void;
  rootMcid?: string;
  deviceType?: number[];
  templateId?: number;
  templateVersion?: number;
  actionType?: ActionType;
  deviceTypeName?: string;
  physicalModelId?: number;
}

const SelectDevices: FC<SelectDevicesProps> = ({
  value,
  onChange,
  rootMcid,
  deviceType,
  templateId,
  templateVersion,
  actionType,
  deviceTypeName,
  physicalModelId,
}) => {
  const [visible, setVisible] = useState<boolean>(false);

  const [modalApi, modalContextHolder] = Modal.useModal();
  const [dataSource, setDataSource] = useState<Key[]>();

  useEffect(() => {
    setDataSource(value);
  }, [value]);

  const onAdd = () => {
    if (rootMcid === undefined) {
      modalApi.warning({
        title: '请先选择所属租户',
      });
      return;
    }
    if (deviceType === undefined) {
      modalApi.warning({
        title: '请先选择所属类目',
      });
      return;
    }
    if (templateId === undefined) {
      modalApi.warning({
        title: '请先选择固定属性模板',
      });
      return;
    }
    setVisible(true);
  };

  const onCancel = () => {
    setDataSource(value ?? []);
    setVisible(false);
  };

  const onOk = () => {
    onChange?.(dataSource);
    setVisible(false);
  };

  return (
    <>
      <Space>
        {value && (
          <div>
            <span>已选择</span>
            <span className={styles.count}>{value?.length || 0}</span>
            <span>个设备</span>
          </div>
        )}
        <Button type="link" onClick={onAdd}>
          {value === undefined ? '请' : '重新'}选择
        </Button>
      </Space>
      <Modal
        className={styles.modal}
        title="设备选择"
        destroyOnClose
        open={visible}
        onOk={onOk}
        onCancel={onCancel}
        width={900}
      >
        <DeviceModal
          rootMcid={rootMcid}
          deviceType={deviceType}
          templateId={templateId}
          actionType={actionType}
          deviceTypeName={deviceTypeName}
          templateVersion={templateVersion}
          physicalModelId={physicalModelId}
          onChange={setDataSource}
          value={dataSource}
        />
      </Modal>
      {modalContextHolder}
    </>
  );
};

export default SelectDevices;
